var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', {
    staticClass: "title"
  }, [_vm.anchor ? [_c('a', {
    attrs: {
      "id": _vm.anchor
    }
  }), _c('a', {
    attrs: {
      "href": '#' + _vm.anchor
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })] : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }